import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AssignmentChip from './AssignmentChip';

const BoardCell = ({
	assignments = [],
	canCreate = false,
	onCreate,
	onEdit,
	showPerson = false,
	minHeight = 72,
}) => {
	const theme = useTheme();
	const hasItems = assignments.length > 0;

	return (
		<Box
			role={canCreate ? 'button' : undefined}
			tabIndex={canCreate ? 0 : undefined}
			onClick={() => {
				if (canCreate) onCreate?.();
			}}
			onKeyDown={(event) => {
				if (!canCreate) return;
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					onCreate?.();
				}
			}}
			sx={{
				position: 'relative',
				minHeight,
				height: '100%',
				p: 0.75,
				cursor: canCreate ? 'pointer' : 'default',
				'&:hover .board-cell-plus, &:focus-within .board-cell-plus': {
					opacity: canCreate && !hasItems ? 1 : 0,
				},
			}}
		>
			{assignments.map((assignment) => (
				<AssignmentChip
					key={assignment.id}
					assignment={assignment}
					onClick={onEdit}
					showPerson={showPerson}
				/>
			))}
			{canCreate && (
				<Box
					className="board-cell-plus"
					sx={{
						position: 'absolute',
						inset: 0,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						pointerEvents: 'none',
						opacity: hasItems ? 0 : { xs: 0.35, md: 0 },
						transition: 'opacity 0.15s ease',
						color: alpha(theme.palette.text.secondary, 0.7),
					}}
				>
					<AddIcon fontSize="small" />
				</Box>
			)}
			{!hasItems && !canCreate && (
				<Typography
					variant="caption"
					sx={{ color: alpha(theme.palette.text.secondary, 0.35) }}
				>
					-
				</Typography>
			)}
		</Box>
	);
};

export default BoardCell;
